module.exports = __webpack_public_path__ + "static/recruit_home__reason-team-6bda9006e787eb1b1c905a04dccafeb6.png";